import React, { useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, SelectUI } from '../Interface';
import dynamicFormService from '../../service/dynamicForm.service';
import { DynmicFormFieldType } from '../../config/DynmicFormFieldType';
import { ProjectlessWorksheetFields } from '../../config/DynamicFormSystemField';

export const VatCodeFields = ({ viewField }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  const [emailTemplates, setEmailTemplates] = useState([]);

  useEffect(() => {
    if (!values.worksheet) return;
    let active = true;
    dynamicFormService.getWorksheetEmailOptions().then((data) => {
      if (active) setEmailTemplates(data?.templates ?? []);
    }).catch(() => {});
    return () => { active = false; };
  }, [values.worksheet]);
  return (
    <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-2 col-span-4">
        <Field
          type="text"
          name="name"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.name} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.name && values.name !== '' }}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="active"
          type="checkbox"
          component={CheckboxUI}
          onChange={(e) => {
            const value = e.target.checked;
            setFieldValue('active', value).then(() => {
              validateField('active');
            });
          }}
          checked={values.active ?? false}
          fullWidth
          label={<FormLabelUI text="Aktív" />}
          disabled={viewField}
        />
      </div>
      <div className="md:col-span-2 col-span-4">
        <Field
          name="worksheet"
          type="checkbox"
          component={CheckboxUI}
          onChange={(e) => {
            const value = e.target.checked;
            setFieldValue('worksheet', value).then(() => {
              validateField('worksheet');
            });
            if (!value) setFieldValue('worksheetEmailTemplateId', null);
          }}
          checked={values.worksheet ?? false}
          fullWidth
          label={<FormLabelUI text="Munkalap" />}
          disabled={viewField}
        />
      </div>
      {values.worksheet && (
        <div className="md:col-span-2 col-span-4">
          <Field
            name="projectRequired"
            type="checkbox"
            component={CheckboxUI}
            onChange={(e) => {
              const value = e.target.checked;
              setFieldValue('projectRequired', value).then(() => {
                validateField('projectRequired');
              });

              const fields = values.dynamicFormField ?? [];
              if (value) {
                setFieldValue(
                  'dynamicFormField',
                  fields
                    .filter((field) => !field.systemRole)
                    .map((field, index) => ({ ...field, visOrder: index + 1 }))
                );
              } else {
                const systemFields = ProjectlessWorksheetFields.map(
                  (systemField) =>
                    fields.find((field) => field.systemRole === systemField.systemRole) ?? {
                      id: uuidv4(),
                      name: systemField.name,
                      type: DynmicFormFieldType.TEXT,
                      defaultValue: null,
                      select: '',
                      autocomplete: false,
                      multiselect: false,
                      userIdMatch: false,
                      dynamicFormFieldOption: [],
                      staticText: '',
                      required: true,
                      onlyWithoutProject: true,
                      systemRole: systemField.systemRole,
                      isNew: true,
                    }
                );
                const regularFields = fields.filter((field) => !field.systemRole);
                const orderedFields = [...systemFields, ...regularFields].map((field, index) => ({
                  ...field,
                  visOrder: index + 1,
                }));

                setFieldValue('dynamicFormField', orderedFields);
              }
            }}
            checked={values.projectRequired ?? true}
            fullWidth
            label={<FormLabelUI text="Projekt megadása kötelező" />}
            disabled={viewField}
          />
        </div>
      )}
      {values.worksheet && (
        <div className="md:col-span-2 col-span-4">
          <SelectUI
            name="worksheetEmailTemplateId"
            value={values.worksheetEmailTemplateId ?? ''}
            onChange={(event) => setFieldValue('worksheetEmailTemplateId', event.target.value === '' ? null : Number(event.target.value))}
            option={[
              { value: '', label: 'Nincs hozzárendelt sablon' },
              ...emailTemplates.map((template) => ({ value: template.id, label: [template.name, template.languageCode].filter(Boolean).join(' - ') })),
            ]}
            label={<FormLabelUI text="E-mail sablon" />}
            disabled={viewField}
          />
        </div>
      )}
    </div>
  );
};

export default VatCodeFields;
